const Actions = {
  Navigate: {
    DO: 'v.employee-new.navigation.actions.navigate.do',
    CONTINUE: 'v.employee-new.navigation.actions.navigate.continue',
    PREVIOUS: 'v.employee-new.navigation.actions.navigate.previous'
  },

  Form: {
    EMPLOYEE_CHANGE: 'v.employee-new.actions.form.employee-change',
    RELATIONSHIP_CHANGE: 'v.employee-new.actions.form.relationship-change',
    DETAIL_CHANGE: 'v.employee-new.actions.form.detail-change'
  },

  Steps: {
    Completed: {
      UPDATE: 'v.employee-new.actions.steps.completed.update'
    },
    ActiveView: {
      SET: 'v.employee-new.actions.steps.active-view.set'
    }
  },

  Confirm: {
    DO: 'v.employee-new.actions.confirm.do'
  },

  Cancel: {
    DO: 'v.employee-new.actions.cancel.do'
  }
};

const Mutations = {
  CLEAR: 'v.mutations.employee-new.clear',
  SET_POLICY_PARTICIPATIONS: 'v.mutations.employee-new.set-policy-participations',

  Form: {
    EMPLOYEE_CHANGE: 'v.employee-new.mutations.form.employee-change',
    RELATIONSHIP_CHANGE: 'v.employee-new.mutations.form.relationship-change',
    DETAIL_CHANGE: 'v.employee-new.mutations.form.detail-change'
  },

  Validations: {
    CLEAR: 'v.mutations.employee-new.validations.clear',
    SET_API: 'v.mutations.employee-new.validations.set-api'
  },

  ActiveView: {
    SET: 'v.employee-new-navigation.mutations.active-view.set',
    CLEAR: 'v.employee-new-navigation.mutations.active-view.clear'
  },

  Steps: {
    Completed: {
      SET: 'v.employee-new.mutations.steps.completed.set'
    },
    Active: {
      SET: 'v.employee-new.mutations.steps.active.set'
    },
    CLEAR: 'v.employee-new.mutations.steps.clear'
  }
};

const Views = {
  Personal: 'v.employee-new.views.personal',
  Employment: 'v.employee-new.views.employment',
  Confirmation: 'v.employee-new.views.confirmation'
};

export default {
  Actions,
  Mutations,
  Views
};
